const stage: string = "beta";

export const getStage = (): string => stage;

const LiteURLStageMap:  Record<string, string> = {
    prod : 'https://lite.myhr.a2z.com/',
    beta : 'https://lite-myhr.pxt.amazon.dev/',
    alpha: 'https://alpha.lite-myhr.pxt.amazon.dev/',
    test: 'https://alpha.lite-myhr.pxt.amazon.dev/',
}

export enum LoginMethod {
    MAASK,
    ATOZ
} ;

// Site codes where language selector is enabled
// Use '*' to enable for all sites, or comma-separated site codes like 'SEA33,PIP13,BLR10'
export const ENABLE_ALL_SITES = '*';

export const LanguageSelectorEnabledSitesMap: Record<string, string> = {
    prod: 'GRU9,BNA7,MQY1',
    beta: 'GRU9,BNA7,MQY1',
    alpha: 'GRU9,BNA7,MQY1',
    test: ENABLE_ALL_SITES,
};

/**
 * Internal helper for testing - checks if language selector is enabled for a given site and stage
 * @param siteCode - The site code to check (e.g., 'SEA54', 'DEN4')
 * @param stageOverride - Optional stage override for testing
 * @returns true if the language selector should be shown
 */
export const isLanguageSelectorEnabledForStage = (
    siteCode: string | null,
    stageOverride: string
): boolean => {
    const enabledSites = LanguageSelectorEnabledSitesMap[stageOverride] ?? '';

    // Empty string = disabled everywhere
    if (!enabledSites) {
        return false;
    }

    // '*' = enabled for all sites
    if (enabledSites === ENABLE_ALL_SITES) {
        return true;
    }

    // Check if site code is in the comma-separated list
    if (!siteCode) {
        return false;
    }

    const siteList = enabledSites.split(',').map(s => s.trim().toUpperCase());
    return siteList.includes(siteCode.toUpperCase());
};

/**
 * Checks if the language selector should be shown for a given site code
 * Uses the current stage from build configuration
 */
export const isLanguageSelectorEnabled = (siteCode: string | null): boolean => {
    return isLanguageSelectorEnabledForStage(siteCode, stage);
};

const RedirectionURLStageMap: Record<LoginMethod, Record<string, string>> = {
    [LoginMethod.MAASK]:{
        prod : 'https://idp.amazon.work/idp/delegate/maask?redirect=https://atoz.amazon.work/myhr?myhr-lite-clientId=MyHR_Lite&deviceType=kiosk',
        beta : 'https://idp-ext-gamma.amazon.work/idp/delegate/maask?redirect=https://atoz.integ.amazon.com/myhr?myhr-lite-clientId=MyHR_Lite&deviceType=kiosk',
        alpha: 'https://idp-ext-gamma.amazon.work/idp/delegate/maask?redirect=https://atoz.integ.amazon.com/myhr?myhr-lite-clientId=MyHR_Lite&deviceType=kiosk',
        test : 'https://idp-ext-gamma.amazon.work/idp/delegate/maask?redirect=https://atoz.integ.amazon.com/myhr?myhr-lite-clientId=MyHR_Lite&deviceType=kiosk',
    },
    [LoginMethod.ATOZ]:{
        prod : 'https://atoz.amazon.work/myhr?myhr-lite-clientId=MyHR_Lite&deviceType=kiosk',
        beta : 'https://atoz.integ.amazon.com/myhr?myhr-lite-clientId=MyHR_Lite&deviceType=kiosk',
        alpha: 'https://atoz.integ.amazon.com/myhr?myhr-lite-clientId=MyHR_Lite&deviceType=kiosk',
        test : 'https://atoz.integ.amazon.com/myhr?myhr-lite-clientId=MyHR_Lite&deviceType=kiosk',
    },

  
}
 
export const getEnvironmentBasedURL = (fileName: string) => {
    return LiteURLStageMap[stage]+fileName+'.png';
}


export const getEnvironmentBasedRedirectionURL = (loginMethod: LoginMethod) => {
    return RedirectionURLStageMap[loginMethod][stage];
}